import {
    SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL,
    SET_REQUEST_APPROVER_ACTIONS_DATA,
    SET_CAPITAL_LEASE_EXPENDITURE_DATA,
    SET_REQUISITION_APPROVAL_DATA,
    SET_QUANTITY_APPROVER_ACTIONS_DATA
} from "./ApprovalType";

const initialState = {
    isItemAndOrderLevelApprovalData: null,
    requestApproverActionData: [],
    quantityApproverActionData: [],
    capitalLeaseExpenditureData: [],
    requisitionApprovalData: {}
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_IS_ITEM_AND_ORDER_LEVEL_APPROVAL:
            return {
                ...state,
                isItemAndOrderLevelApprovalData: action.isItemAndOrderLevelApprovalData,
            };
        case SET_REQUEST_APPROVER_ACTIONS_DATA:
            return {
                ...state,
                requestApproverActionData: action.requestApproverActionData,
            };
            case SET_QUANTITY_APPROVER_ACTIONS_DATA:
            return {
                ...state,
                quantityApproverActionData: action.quantityApproverActionData,
            };
        case SET_CAPITAL_LEASE_EXPENDITURE_DATA:
            return {
                ...state,
                capitalLeaseExpenditureData: action.capitalLeaseExpenditureData,
            };
        case SET_REQUISITION_APPROVAL_DATA:
            return {
                ...state,
                requisitionApprovalData: action.requisitionApprovalData,
            };
        default:
            return state;
    }
};

export default reducer;
